import { Box } from '@chakra-ui/react'

const StoreApp = (props) => {
  return <Box>{props.children}</Box>
}

export default StoreApp
